import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { IROH_SERVICES_API_PREFIX } from "@/api/domain"

// Minimal public project information
type PublicProjectInfo = {
  id: string
  name: string
  description?: string
}

// Define a service for public endpoints that don't require authentication
export const publicApi = createApi({
  reducerPath: "publicApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${IROH_SERVICES_API_PREFIX}projects/public`,
    mode: "cors",
    // No credentials for public endpoints
  }),
  endpoints: (build) => ({
    publicProjectsGetByName: build.query<
      PublicProjectInfo,
      { username: string; project_name: string }
    >({
      query: ({ username, project_name }) => ({
        url: `${username}/${project_name}`,
      }),
    }),
  }),
})

export const { usePublicProjectsGetByNameQuery } = publicApi
